export default __webpack_public_path__ + "3c112008af9400c2a51dd929bed77db3.glb";